import idleService from './idleService';

export default idleService;
